/* eslint-disable security/detect-object-injection */
import React, { useContext, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { TextInput, useModal } from '@jutro/components';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { getApdLobs, getApdLobQuoteUrl } from '@xengage/gw-portals-url-js';
import { JobUtil } from '@xengage/gw-portals-util-js';
import { SubmissionService, OrganizationService, UserService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import { useTranslator } from '@jutro/locale';
import htmlParser from 'html-react-parser';

import appConfig from 'app-config';
import { ServiceManager } from '@jutro/legacy/services';
import InsClassHelpComponent from "premier-capability-policyjob-react/components/InsClassHelpComponent/InsClassHelpComponent";
import metadata from './NewSubmissionPage.metadata.json5';
import styles from './NewSubmissionPage.module.scss';
import messages from '../../NewQuoteAccountSearch.messages';
import gatewayMessages from '../../../gateway.messages';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import { ModalBody, ModalNext, ModalHeader, ModalFooter } from '@jutro/components';
import { Button, DateField } from '@jutro/legacy/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

function NewSubmissionPage(props) {
    const {
        showAlert,
        showConfirm,
        showModal
    } = useModal();

    const viewModelService = useContext(ViewModelServiceContext);
    const {
        isAnExistingAccount,
        submissionVM,
        postalCode,
        updateSubmissionVM,
        producerCodeValue,
        isAgent,
        allOrganisationValue,
        authHeader,
        producerDisplayName,
        actproducerCodeDetail
    } = props;
    const [productValue, updateProductValue] = useState([]);
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);
    const [selectedOrganisationValue, updateOrganisation] = useState(_.get(actproducerCodeDetail, 'organizationDTO_Ext.publicID'));
    const [showErrors, updateShowErrors] = useState([false]);
    const [isOpen, setIsOpen] = useState(true);
    const [brokerName, updateBrokerName] = useState(undefined);
    const { history } = props;
    const { lobQuoteURL } = appConfig;
    const translator = useTranslator();
    const { onValidate, isComponentValid } = useValidation('NewSubmissionPage');

    const selectedLanguage = ServiceManager.getService('locale-service').getStoredLanguage()

    const startSubmission = useCallback(async () => {
        const productCode = _.get(submissionVM, 'productCode.value');

        if (!_.isNil(getApdLobQuoteUrl(productCode))) {
            const accountId = _.get(submissionVM, 'accountPublicId');
            const nextLocation = {
                productCode,
                accountId,
                jobId: undefined
            };

            history.push(getApdLobQuoteUrl(productCode), nextLocation);
        } else {
            const newSubmissionResponse = await SubmissionService.createSubmission(
                submissionVM.value,
                authHeader
            );

            if (newSubmissionResponse.jobNumber > 0) {
                if (!_.isNil(lobQuoteURL[productCode])) {
                    const nextLocation = {
                        quoteentry: {
                            postalCode,
                            quoteID: newSubmissionResponse.jobNumber
                        },
                        productCode
                    };

                    history.push(lobQuoteURL[productCode], nextLocation);
                }
                else {
                    JobUtil.openJobInXCenter(newSubmissionResponse.jobNumber);
                }
            }
        }
    }, [submissionVM, history, authHeader, lobQuoteURL, postalCode]);

    const inferProductName = (productCode) => {
        const productName = productCode.replace(/([A-Z])/g, ' $1');

        return productName.charAt(0).toUpperCase() + productName.slice(1);
    };

    const refreshProducts = useCallback(
        async (newSubmissionVM) => {
            try {
                const submission = {
                    ...newSubmissionVM.value,
                    // product code is a required field and must have a value
                    productCode: _.get(newSubmissionVM, 'productCode.value', '')
                };
                const productCodeResponse = await AccountService.getAvailableProductsForAccount(
                    submission,
                    authHeader
                );
                const productCodeValues = productCodeResponse;
                const peSupportedLines = !_.isUndefined(selectedLanguage) && selectedLanguage === 'fr-CA' ? appConfig.supportedLinesForFR : appConfig.supportedLines
                const productCodeAvailableValue = productCodeValues
                    .filter((value) => !value.isRiskReserved && peSupportedLines.includes(value.productCode))
                    .map(({ productCode, productName }) => ({
                        code: productCode,
                        name: productName
                    }));
                const apdLobs = getApdLobs().map((productCode) => ({
                    code: productCode,
                    name: inferProductName(productCode)
                }));

                apdLobs
                    .forEach((apdLob) => {
                        const element = productCodeAvailableValue.find((lob) => lob.code === apdLob.code);

                        if (element === undefined) {
                            productCodeAvailableValue.push(apdLob);
                        }
                    });

                updateProductValue(productCodeAvailableValue);
            } catch {
                updateProductValue([]);
                showAlert({
                    title: gatewayMessages.modalError,
                    message: gatewayMessages.gatewayViewsModalErrorData,
                    status: 'error',
                    icon: 'mi-error-outline'
                }).catch(_.noop);
            }
        },
        [authHeader, selectedLanguage, showAlert]
    );

    const getProducerCodesOrganization = useCallback(
        async (organisationCode) => {
            const producerCodeResponse = await OrganizationService.getProducerCodeForOrganization(
                organisationCode,
                authHeader
            );
            const producerCodeOrganisation = producerCodeResponse.map((value) => ({
                code: value.code,
                name: value.displayValue,
                displayName: value.description
            }));

            updateProducerCodeValue(producerCodeOrganisation);
            _.set(submissionVM, 'producerCode', '');
            _.set(submissionVM, 'productCode', '');
            updateSubmissionVM(submissionVM);
        },
        [authHeader, submissionVM, updateSubmissionVM]
    );

    const handleValueOrganisation = (value) => {
        let organisationCode = {};

        const selectedOrganisation = value;

        allOrganisationValue.forEach((result) => {
            if (result.code === selectedOrganisation) {
                organisationCode = {
                    displayName: result.name,
                    publicID: result.code
                };
            }
        });
        getProducerCodesOrganization(organisationCode);
        updateOrganisation(value);
    };

    const getProducerName = () => {
        let prdDisNam = _.filter(producerDisplayName, (prdDisplayName) => prdDisplayName.code === submissionVM.value.producerCode)

        if (prdDisNam.length === 0) {
            prdDisNam = _.filter(producerCodeOrgValue, (prdDisplayName) => prdDisplayName.code === submissionVM.value.producerCode)

            if (!_.isUndefined(prdDisNam[0])) {
                return prdDisNam[0].displayName
            }

            return prdDisNam
        }

        return prdDisNam[0].name
    };

    useEffect(() => {
        async function fetchBrokerData() {
            const response = await UserService.getGatewayCurrentUser(authHeader);
            updateBrokerName(response?.displayName);
        }
        fetchBrokerData();
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getOfferings = (productCodeP) => {
        const productCode = _.isUndefined(productCodeP) ? _.get(submissionVM, 'productCode.value') : productCodeP
        let offerings = []

        if (productCode === 'RecVehProduct') {
            offerings = appConfig.prvAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'ProLinProduct') {
            offerings = appConfig.pplAllowedOffering.map((offCode) => ({
                code: offCode,
                name: {
                    id: `typekey.PPLSelOff.${offCode}`,
                    defaultMessage: offCode
                }
            }))
        }

        if (productCode === 'EnvProduct') {
            offerings = appConfig.pelAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'EveLiaProduct') {
            offerings = appConfig.pleAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'SpoAndRecProduct') {
            offerings = appConfig.psrAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'RecMarProduct') {
            offerings = appConfig.prmAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'SpeLinProduct') {
            offerings = appConfig.pscAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'SpaAndWelProduct') {
            offerings = appConfig.pswAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'ConsTraAndServProduct') {
            offerings = appConfig.pctAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'PerProduct') {
            offerings = appConfig.pprAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (productCode === 'CybLiaProduct') {
            offerings = appConfig.pclAllowedOffering.map((offCode) => ({
                code: offCode,
                name: messages[offCode]
            }))
        }

        if (!_.isUndefined(selectedLanguage) && selectedLanguage === 'fr-CA' && offerings.length > 0) {
            offerings = _.filter(offerings, (offering) => !appConfig.unsupportedOfferingForFR.includes(offering.code));
        }

        return offerings

    };

    const setProductCodeForOffering = (value) => {
        const newSubmissionVMClone = viewModelService.clone(submissionVM);

        _.set(newSubmissionVMClone.value, 'productCode_Ext', value);
        _.set(newSubmissionVMClone.value, 'productCode', value);
        updateSubmissionVM(newSubmissionVMClone);

    };


    const writeValue = useCallback(
        (value, path) => {
            const accountId = _.get(submissionVM, 'accountPublicId');
            const newSubmissionVMClone = viewModelService.clone(submissionVM);

            _.set(newSubmissionVMClone.value, path, value);
            _.set(newSubmissionVMClone.value, 'accountPublicId', accountId);
            updateSubmissionVM(newSubmissionVMClone);

            if (
                (path === 'producerCode' || path === 'effectiveDate' || path === 'state')
                && !!(
                    _.get(newSubmissionVMClone, 'producerCode.value')
                    && _.get(newSubmissionVMClone, 'state.value.code')
                    && _.get(newSubmissionVMClone, 'effectiveDate.value')
                )
            ) {
                refreshProducts(newSubmissionVMClone);
                _.set(newSubmissionVMClone.value, 'productCode', '');
                _.set(newSubmissionVMClone.value, 'accountPublicId', accountId);
                updateSubmissionVM(newSubmissionVMClone);
            }
        },
        [refreshProducts, submissionVM, updateSubmissionVM, viewModelService]
    );

    const handleCancel = useCallback(() => {
        const accountNumber = _.get(submissionVM, 'accountNumber.value');

        showConfirm({
            title: htmlParser(translator(messages.cancelQuote)),
            message: messages.cancelMessage,
            status: 'warning',
            icon: 'mi-error-outline'
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            if (accountNumber) {
                history.push(`/accounts/${accountNumber}/summary`);
            } else {
                history.push('/');
            }

            return true;
        }, _.noop);
    }, [history, showConfirm, submissionVM, translator]);

    const handleValidation = useCallback(() => {
        updateShowErrors(true);
    }, [updateShowErrors]);

    // const producerdisable = producerCodeOrgValue.length > 0
    //     ? isAgent : producerCodeOrgValue.length === 0;

    // const isAgentProducer = !isAgent ? producerdisable : !isAnExistingAccount;

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: false,
            showRequired: true
        },
        submissionProducerCode: {
            // availableValues: [{code: 'AGT122', name: 'AGT122'}],
            availableValues:
                _.isArray(producerCodeValue) && producerCodeValue.length > 0
                    ? producerCodeValue
                    : producerCodeOrgValue,
            // disabled: isAgentProducer,
            defaultValue: _.get(actproducerCodeDetail, 'code')
        },
        submissionState: {
            disabled: !isAnExistingAccount
        },
        submissionDate: {
            minDate: new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }))
        },
        submissionProductCode: {
            availableValues: productValue,
            disabled: !_.get(submissionVM, 'producerCode.value'),
            onValueChange: setProductCodeForOffering
        },
        submissionOrganisation: {
            visible: !isAgent,
            availableValues: allOrganisationValue,
            onValueChange: handleValueOrganisation,
            value: selectedOrganisationValue
        },
        offerings: {
            availableValues: getOfferings(undefined),
            disabled: !_.get(submissionVM, 'productCode.value')
        },
        cancel: {
            disabled: !isAnExistingAccount
        },
        next: {
            disabled: !isAnExistingAccount
        },
        producerName: {
            value: brokerName
        }

    };

    const createhelpData = useCallback(() => {
        const result = []

        _.each(productValue, (val) => {
            const offerings = getOfferings(val.code)

             _.each(offerings, (off) => {
                result.push(
                    {
                        insuranceClass: val.name,
                        product: translator(off.name)
                    }
                )
            });
        });

        return result

    },[getOfferings, productValue, translator])

    const showModelForProducts = useCallback(() => {
         const componentProps = {
            forms: createhelpData()
            };

        showModal(
         <InsClassHelpComponent {...componentProps}/>
    )
    }, [createhelpData, showModal]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            startSubmission: isComponentValid ? startSubmission : handleValidation,
            onCancel: handleCancel,
            showModelForProducts
        },
        resolveComponentMap: {
            TextInput
        }
    };

    const readValue = (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValidationChange={onValidate}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            showErrors={showErrors}
        />
    );
}

NewSubmissionPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    isAnExistingAccount: PropTypes.bool,
    submissionVM: PropTypes.shape({
        value: PropTypes.shape({})
    }),
    allOrganisationValue: PropTypes.shape({}),
    postalCode: PropTypes.string,
    updateSubmissionVM: PropTypes.func,
    producerCodeValue: PropTypes.arrayOf(PropTypes.string),
    producerDisplayName: PropTypes.arrayOf(PropTypes.string),
    isAgent: PropTypes.bool,
    authHeader: PropTypes.shape({})
};

NewSubmissionPage.defaultProps = {
    isAnExistingAccount: false,
    submissionVM: {},
    allOrganisationValue: [],
    postalCode: '',
    updateSubmissionVM: undefined,
    producerCodeValue: [],
    producerDisplayName: [],
    isAgent: false,
    authHeader: {}
};
export default withRouter(NewSubmissionPage);